<template>
  <div class="box-spec-fields" :class="{ compact }">
    <div class="spec-head">
      <span>重量和箱规</span>
      <em>选填</em>
    </div>
    <div class="spec-grid">
      <div class="spec-item">
        <div class="spec-label">重量</div>
        <el-input v-model="local.weight" maxlength="10" @input="emitChange" @change="emitChange">
          <template slot="append">g</template>
        </el-input>
        <small v-if="errors.weight">{{ errors.weight }}</small>
      </div>
      <div class="spec-item">
        <div class="spec-label">长</div>
        <el-input v-model="local.length" maxlength="10" @input="emitChange" @change="emitChange">
          <template slot="append">cm</template>
        </el-input>
        <small v-if="errors.length">{{ errors.length }}</small>
      </div>
      <div class="spec-item">
        <div class="spec-label">宽</div>
        <el-input v-model="local.width" maxlength="10" @input="emitChange" @change="emitChange">
          <template slot="append">cm</template>
        </el-input>
        <small v-if="errors.width">{{ errors.width }}</small>
      </div>
      <div class="spec-item">
        <div class="spec-label">高</div>
        <el-input v-model="local.height" maxlength="10" @input="emitChange" @change="emitChange">
          <template slot="append">cm</template>
        </el-input>
        <small v-if="errors.height">{{ errors.height }}</small>
      </div>
    </div>
    <small v-if="errors.spec" class="spec-error">{{ errors.spec }}</small>
  </div>
</template>

<script>
export default {
  name: "BoxSpecFields",
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    errors: {
      type: Object,
      default: () => ({
        weight: "",
        length: "",
        width: "",
        height: "",
        spec: "",
      }),
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      local: this.copySpec(this.value),
    };
  },
  watch: {
    value: {
      deep: true,
      handler(next) {
        this.local = this.copySpec(next);
      },
    },
  },
  methods: {
    copySpec(source = {}) {
      return {
        weight: this.toInput(source.weight),
        length: this.toInput(source.length),
        width: this.toInput(source.width),
        height: this.toInput(source.height),
      };
    },
    toInput(value) {
      return value === undefined || value === null ? "" : String(value);
    },
    emitChange() {
      this.$emit("input", {
        weight: this.local.weight,
        length: this.local.length,
        width: this.local.width,
        height: this.local.height,
      });
    },
  },
};
</script>

<style scoped>
.box-spec-fields {
  width: 100%;
}

.spec-head {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  color: #596675;
  font-weight: 500;
}

.spec-head em {
  font-style: normal;
  color: #8c939d;
  font-size: 12px;
  font-weight: 400;
}

.spec-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px 8px;
  width: 100%;
}

.compact .spec-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.spec-item {
  min-width: 0;
}

.spec-label {
  margin-bottom: 6px;
  color: #596675;
  font-size: 12px;
  line-height: 1;
}

.spec-item ::v-deep .el-input,
.spec-item ::v-deep .el-input-group {
  width: 100%;
}

.spec-item ::v-deep .el-input-group__append {
  padding: 0 8px;
  width: 32px;
  color: #909399;
}

.spec-error {
  display: block;
  margin-top: 6px;
  color: #ff0000;
  font-size: 12px;
  line-height: 16px;
}

.spec-item small {
  display: block;
  margin-top: 4px;
  color: #ff0000;
  font-size: 12px;
  line-height: 16px;
}
</style>
